export const handleError = (err) => {
    return {...err?.error, error: err?.error || err?.data, code: err?.status || 400}
}

export const toFriendlyApiErrorMessage = (raw = "") => {
    const text = String(raw || "").trim();
    if (!text) return "";
    const lower = text.toLowerCase();

    if (
        lower.includes("string length must be greater than or equal to 1") ||
        lower.includes("invalid request body") ||
        (lower.includes("must not be empty") && lower.includes("request body"))
    ) {
        return "Please fill in all required fields.";
    }

    if (
        lower.includes("invalid credentials") ||
        lower.includes("invalid username") ||
        lower.includes("invalid password")
    ) {
        return "Unable to login due to invalid credentials. Please try again with the correct username and password.";
    }

    if (lower.includes("account is locked") || lower.includes("locked due to")) {
        return "Account is locked due to multiple incorrect password attempts. Please reset the password and try again.";
    }

    if (lower.includes("password has expired") || lower.includes("password expired")) {
        return "Password has expired. Please reset the password and try again.";
    }

    return text;
};

export const getApiErrorMessage = (errorPayload) => {
    if (!errorPayload) {
        return "Unknown error, please try again later.";
    }

    if (typeof errorPayload === "string") {
        return toFriendlyApiErrorMessage(errorPayload);
    }

    const apiError = errorPayload?.error ?? errorPayload;

    if (typeof apiError === "string") {
        return toFriendlyApiErrorMessage(apiError);
    }

    if (apiError?.message) {
        return toFriendlyApiErrorMessage(apiError.message);
    }

    if (errorPayload?.message) {
        return toFriendlyApiErrorMessage(errorPayload.message);
    }

    if (errorPayload?.code) {
        const detail =
            (typeof errorPayload?.error === "string" && errorPayload.error) ||
            errorPayload?.error?.message ||
            errorPayload?.statusText ||
            "";
        if (detail) {
            return toFriendlyApiErrorMessage(detail);
        }
        return `Request failed (${errorPayload.code}). No error details from server.`;
    }

    return "Unknown error, please try again later.";
}